module.exports = __webpack_public_path__ + "img/download-icon.bd51ce72.svg";